(function () {
  function unmuteNearbyVideo(startEl) {
    // Look for a video that was just injected by <deferred-media>
    const root =
      startEl.closest('.product__media, .product__media-item, .media, .deferred-media, .product-media-modal') ||
      document;

    const video = root.querySelector('video');
    if (!video) return;

    // Must happen after user gesture; this click qualifies.
    video.muted = false;
    video.volume = 1;

    // If Dawn started playback muted, try to resume with audio allowed.
    // (If it’s already playing, this is harmless.)
    const p = video.play?.();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  }

  // When the user clicks the poster/play button, Dawn injects <video> shortly after.
  document.addEventListener('click', (e) => {
    const poster = e.target.closest('.deferred-media__poster, .deferred-media__poster-button');
    if (!poster) return;

    // Give Dawn a tick to inject the template content
    setTimeout(() => unmuteNearbyVideo(poster), 50);
    setTimeout(() => unmuteNearbyVideo(poster), 250); // second attempt for slower devices
  });

  // Also handle the case where video gets injected and then played later
  document.addEventListener(
    'play',
    (e) => {
      const v = e.target;
      if (!(v instanceof HTMLVideoElement)) return;
      v.muted = false;
      v.volume = 1;
    },
    true
  );
})();